import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { ConfirmationDialog } from '../ConfirmationDialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent implements OnInit, AfterViewInit , OnDestroy {

  @Input() confirmationDialog: ConfirmationDialog;
  @Output() onConfirmDialog: EventEmitter<any> = new EventEmitter<any>();

  private mdlConfirmationDialogControl: any;

  @ViewChild('mdlConfirmationDialog', {static: false}) mdlConfirmationDialog;
  ngAfterViewInit() {
    this.initModal();
  }

  constructor(
    private readonly _modalService: NgbModal,
  ) { }

  public ngOnInit(): void {
    /** Necesary for AfterViewInit */
  }

  public ngOnDestroy(): void {
    this.mdlConfirmationDialogControl.close();
    this.onConfirmDialog.unsubscribe();
  }

  protected initializaDialog(action: any): void{
    this.mdlConfirmationDialogControl.close();
    this.onConfirmDialog.emit(action);
  }

  protected initModal(): void {
    this.mdlConfirmationDialogControl = this._modalService.open(this.mdlConfirmationDialog, { size: 'xl' });
  }

}
